export default __webpack_public_path__ + "static/media/cover 2.f9df63c9.jpg";